import { getClientProductStock } from 'product/services/productStock/client/getClientProductStock'
import type { CountryConfiguration } from 'types/countryConfiguration'

import type { Color, FullProduct } from '../../types/FullProduct'
import { getClientRelatedStock } from '../getFullProduct/getClientRelatedStock'
import { getSizes } from '../getFullProduct/getSizes'
import { getHasLastUnits } from '../getHasLastUnits/getHasLastUnits'
import { getIsSellableColor } from '../getIsSellableColor/getIsSellableColor'

interface GetRevalidatedColors {
	product: FullProduct
	country: CountryConfiguration
}

export const getRevalidatedColors = async ({
	product,
	country,
}: GetRevalidatedColors): Promise<{
	revalidatedColors: Color[] | null
}> => {
	const [stock, relatedSizesStock] = await Promise.all([
		getClientProductStock({
			country: country.countryISO,
			productId: product.id,
		}),
		getClientRelatedStock(
			{
				productId: product.id,
				country: country.countryISO,
				language: country.languageISO,
			},
			product
		),
	])

	if (!stock) {
		return { revalidatedColors: null }
	}

	const revalidatedColors = product.colors.map((color) => {
		const sizes = getSizes({
			stock,
			relatedSizesStock,
			defaultWarehouseId: country.warehouse.defaultId,
			productColor: color,
		})

		const lastUnits = getHasLastUnits({ sizes })
		const isSellable = getIsSellableColor({ country, sizes })

		return {
			...color,
			sizes,
			lastUnits,
			isSellable,
		}
	})

	return { revalidatedColors }
}
